import Root from './root';
import render from 'utils/renderToDOM';

render(Root, 'payment-area');



// WEBPACK FOOTER //
// ./src/payments/entry.js